import { Router } from 'vue-router';
import { errorRoutes } from './errorRoutes';
import { standardRoutes } from './standardRoutes';
import { signUpRoutes } from './signUpRoutes';
import { releaseRoutes } from './releaseRoutes';

export async function addStandardRoutes(router: Router) {
  await errorRoutes.forEach((route) => router.addRoute(route));
  await standardRoutes.forEach((route) => router.addRoute(route));
  await signUpRoutes.forEach((route) => router.addRoute(route));
  await releaseRoutes.forEach((route) => router.addRoute(route));
}
